import React from 'react'

// the refresh action from the webapp's report-download header slot
// (report downloads are intentionally not available in the CRM)
const RefreshButton = ({ onRefresh }) => {
  return (
    <div className="report-download">
      <button
        className="btn btn-outline-secondary btn-clearout-refresh"
        title="Refresh"
        onClick={onRefresh}
      >
        <i className="fa fa-refresh"></i>
      </button>
    </div>
  )
}

export default RefreshButton
